module.exports = __webpack_public_path__ + "static/img/addDeviceBg.43b3d86a.png";